module.exports = __webpack_public_path__ + "assets/game-type-vocabulary.b5884d22.svg";